import React, { useEffect, useContext } from "react";
import exploreCourses from "../Assets/img/profile/image 36.png";
import styles from "../Assets/css/overview.module.css";
import { store } from "react-notifications-component";
import { AuthContext } from "../Context/AuthContext";
import { useHistory } from "react-router-dom";
import { BASE_URL } from "../env";

function Sidebar() {
	const { token, update_token } = useContext(AuthContext);
	const history = useHistory(0);

	// useEffect(() => {
	//   fetch(BASE_URL + "/getProfile", {
	//     headers: { authorization: "Bearer " + localStorage.getItem("token") },
	//   })
	//     .then((res) => res.json())
	//     .then((data) => {
	//       console.log(data);
	//       //console.log(userinfo)
	//       // userinfo.setuserinfo(data)

	//       // console.log(userinfo)
	//       // if (data.error) {
	//       //   setFirstName("");
	//       // } else {
	//       //   setData(data);
	//       //   //  userinfo.setuserinfo(data)
	//       //   setLoggedin(true);
	//       //   setId(data.user._id);
	//       //   set_Id(data.user._id);
	//       //   setFirstName(data.user.firstName);
	//       //   setIsAdmin(data.user.isAdmin);
	//       //   setProfilePic(data.user.profile_pic);
	//         //console.log(userinfo)
	//       // }
	//     });
	// }, [token]);

	const notifyPopup = (backend_message, type) => {
		store.addNotification({
			title: backend_message,
			message: backend_message,
			type: type,
			background: "pink",
			insert: "bottom",
			container: "bottom-right",
			animationIn: ["animate__animated", "animate__fadeIn"],
			animationOut: ["animate__animated", "animate__fadeOut"],
			dismiss: {
				duration: 3000,
				onScreen: true,
			},
		});
	};

	const logout = () => {
		localStorage.clear();
		update_token("");
		notifyPopup("You are Logged Out!!", "danger");
		history.push("/");
	};

	return (
		<div className={`col-xl-2 ${styles.sidebar}`}>
			<ul className={styles.no_bullets}>
				<li className={styles.list_items}>
					<a href="#" className={styles.profile_link}>
						<span
							className={`material-icons-outlined ${styles.material_icons_outlined}`}
						>
							home
						</span>
						<span className={styles.link_text}>Overview</span>
					</a>
				</li>
				<li className={styles.list_items}>
					<a href="/mycourse" className={styles.profile_link}>
						<span
							className={`material-icons ${styles.material_icons}`}
						>
							notes
						</span>
						<span className={styles.link_text}>My Courses</span>
					</a>
				</li>
				<li className={styles.list_items}>
					<a href="#" className={styles.profile_link}>
						<span
							className={`material-icons ${styles.material_icons}`}
						>
							content_paste
						</span>
						<span className={styles.link_text}>Assignments</span>
					</a>
				</li>
				<li className={styles.list_items}>
					<a href="/blog" className={styles.profile_link}>
						<span
							className={`material-icons ${styles.material_icons}`}
						>
							cloud_queue
						</span>
						<span className={styles.link_text}>
							Resource center
						</span>
					</a>
				</li>
				<li className={styles.list_items}>
					<a href="/user/:id" className={styles.profile_link}>
						<span
							className={`material-icons ${styles.material_icons}`}
						>
							person_outline
						</span>
						<span className={styles.link_text}>Profile</span>
					</a>
				</li>
				<li className={`${styles.list_items} ${styles.list_logout}`}>
					<div
						onClick={() => logout()}
						className={styles.profile_link}
					>
						<span
							className={`material-icons ${styles.material_icons}`}
						>
							logout
						</span>
						<span className={styles.link_text}>Logout</span>
					</div>
				</li>
			</ul>
			<img
				src={exploreCourses}
				alt=""
				className={`${styles.rec_img} img-fluid`}
			/>
		</div>
	);
}

export default Sidebar;
